import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import ImpactPanel from './ImpactPanel'
import { NO_SYSTEM_VALUES } from './systemValueTerms'

/**
 * Historia 176 — CA9, T6 (S105-S113, S152, S181, `S105-confirmacion-antes-de-cambiar-jupiter.feature`).
 * Shown before a save, delete ("Undo customisation") or restore that `needsConfirmation` (`impact.js`)
 * gates: the caller decides whether to open it (RN9), this component only draws it (RN9b, DC-18):
 * the title says what changes, T59 `Change "{{from}}" → "{{to}}"?` (`from` = what is painted today,
 * `to` = what will be painted, both given by the caller); the body is the impact block shared with
 * the popover of the usage chip (`ImpactPanel`, DC-26: the common-structure block T67 with its sites above;
 * below, T68 or T60, a chip per module and the screen list folded); the buttons are `Cancel` and T58 `Apply change`. The caller
 * owns what `onConfirm` actually sends (03 §7: the confirmation itself never reaches Sun).
 */
const ConfirmChangeDialog = ({ open = false, termKey = '', from = '', to = '', artifact = {}, systemValues = NO_SYSTEM_VALUES, onConfirm = () => {}, onCancel = () => {} }) => {
  const { t_ } = useSmartTranslation()

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>
        {t_('Change "{{from}}" → "{{to}}"?', { from, to })}
      </DialogTitle>
      <DialogContent>
        <ImpactPanel termKey={termKey} artifact={artifact} systemValues={systemValues} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t_('Cancel')}</Button>
        <Button onClick={onConfirm}>{t_('Apply change')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmChangeDialog
